import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";

declare var ko: any;

export class contentPresetList_template extends vnTemplate {


    //As VM
    protected resultInfos: resultsInfo_template;
    protected pagination: pagination_template;

    protected initPartial() {
        this.resultInfos = new resultsInfo_template('resultInfo', this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
    }

    public getViewModelForRequest(): any {
        return {
            orderBy: this.getTemplateViewModel().orderBy,
            orderByDirection: this.getTemplateViewModel().orderByDirection,
            orderByAndDirection: this.getTemplateViewModel().orderByAndDirection,
            pagination: this.getTemplateViewModel().pagination,
        }
    }

    protected buildViewModel(): any {
        let self = this
        return {
            contentpresets: ko.observableArray([]),
            orderBy: ko.observable("itemName"),
            orderByDirection: ko.observable("DESC"),
            orderByAndDirection: ko.observable("itemName_DESC"),
            idContentPresetToDelete: ko.observable(null),
            onClickReorder: (value, data, event) => {
                self.onClickReorder(value, data, event);
            },
            viewContentPreset: (data, event) => {
                self.viewContentPreset(data.id, event);
            },
            onClickAdd: (data, event) => {
                self.onClickAdd()
            },
            onClickShowPopUp : (data, event) =>{
                self.onClickShowPopUp(data)
            },
            onClickHidePopUp : (data, event)=>{
                self.onClickHidePopUp()
            },
            onClickDelete : (data, event)=>{
                self.onClickDelete()
            }
        }
    }

    protected getTemplateHtml(): string {
        return (`
        <div class="list-header w-justify">
            <div class="w-left" >
                    <button data-bind="event: {click: onClickAdd}" class="btn secondary icon i-add" type="button">Add a content preset</button>    
            </div>
            <div class="w-right">
                ` + this.pagination.getHtmlBuild() + `
            </div>
        </div>
        
        <div class="w-list-results" id="list-results">
            <table class="list-results">
                ` + this.resultInfos.getHtmlBuild() + `
                    <thead>
                        <tr>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'isActive') }, css: { 'list-sort-desc': orderByAndDirection()=='isActive_DESC', 'list-sort-asc': orderByAndDirection()=='isActive_ASC' }">Is Active</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'type') }, css: { 'list-sort-desc': orderByAndDirection()=='type_DESC', 'list-sort-asc': orderByAndDirection()=='type_ASC' }">Type</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'itemName') }, css: { 'list-sort-desc': orderByAndDirection()=='itemName_DESC', 'list-sort-asc': orderByAndDirection()=='itemName_ASC' }">Item Name</span></th>
                            <th class="align-right"><span>Delete</span></th>
                        </tr>
                    </thead>
                    <div data-bind="text: console.log(contentpresets())"></div>
                    <tbody data-bind="foreach: contentpresets">
                        <tr class="cursor">
                            <td data-bind="event: { click: $parent.viewContentPreset } "><a class="right-click" data-bind="attr: {href: emakiView}"><span data-bind="text: isActive"></span></a></td>
                            <td data-bind="event: { click: $parent.viewContentPreset } "><a class="right-click" data-bind="attr: {href: emakiView}"><span data-bind="text: type"></span></a></td>                          
                            <td data-bind="event: { click: $parent.viewContentPreset } "><a class="right-click" data-bind="attr: {href: emakiView}"><span data-bind="text: itemName"></span></a></td>
                            <td class="align-right">
                                <button type="button" data-bind="event: { click: $parent.onClickShowPopUp }, clickBubble: false" class="btn border only-icon highlight icon i-delete" />
                            </td>
                        </tr>
                        
                    </tbody>
                </table>
            </div> 
            
            
            <div id="delete-dialog" class="w-lightbox light-theme">
                <div class="lightbox-content">
                        
                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Deleting content preset</h3>
                            <button type="button"  data-bind="event: { click: onClickHidePopUp }" class="close-button icon i-close-2"></button>
                        </div>
                   
                        <div class="form-body">
                            <div class="form-group">
                                <p class="form-text">This action is irreversible</p>
                                <p class="form-text">Are you sure you want to delete this content preset :

                                    <p data-bind=" if: idContentPresetToDelete() !== null ">
                                       <span data-bind="text: idContentPresetToDelete().itemName"></span>
                                    </p>

                                </p>
                            </div>
                         </div>
                
                        <div class="form-footer">
                            <button type="button" data-bind="event: { click: onClickHidePopUp }" class="btn">Cancel</button>
                            <button type="button" data-bind="event: { click: onClickDelete }" class="btn highlight">Delete</button>
                        </div>
                    </div>
                   
                </div>
            </div>
        `);
    }

    protected getTemplateName(): string {
        return "contentPresetList_template";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-content"];
    }

    protected getMainElementType(): string {
        return "div";
    }

    public setResultInfo(nbResults, nbPages, execTime) {

        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    protected viewContentPreset(data, event): any {
        this.caller.viewContentPreset(data)
    }

    protected onClickReorder(value, data, event): any {

        data.orderBy(value);
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.contentPresetsListReorder();
    }

    onClickAdd(): any {
        this.caller.addContentPreset()
    }

    onClickDelete() {
        let content_preset_id = this.getTemplateViewModel().idContentPresetToDelete();
        this.toggleDeleteDialogVisibility();
        this.caller.deleteContentPreset(content_preset_id);
    }

    onClickHidePopUp(): any {
        this.getTemplateViewModel().idContentPresetToDelete(null);
        this.toggleDeleteDialogVisibility()
    }
    onClickShowPopUp(data): any {

        this.getTemplateViewModel().idContentPresetToDelete(data);
        this.toggleDeleteDialogVisibility()
    }

    //Action on view model
    protected setContentPresets(contentpresets, brandId) {

        contentpresets.forEach((cp) => cp['emakiView'] = '/brand/' + brandId + '/config/content-presets/view/' + cp.id + '/');
        this.getTemplateViewModel().contentpresets(contentpresets)
    }

    public toggleDeleteDialogVisibility() {

        document.getElementById('delete-dialog').classList.toggle('is-visible');
    }


}


// WEBPACK FOOTER //
// ./js/components/templates/contentPresetList_template.ts